import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AppService, CoreTypes, LabelValue } from 'common-cloudstudio';
import { GearAppService } from 'common-gear';
import { forkJoin, Subscription, Observable, of } from 'rxjs';
import { ApolusProxyService, ApolusTypes } from 'src/app/customer-modules/apolus/shared/services/apolus-proxy.service';
import { ApolusService } from 'src/app/customer-modules/apolus/shared/services/apolus.service';

export enum WidgetType {
  ConectivityTable = 1874422,
  ConnectivityHistory = 1874423,
  DeviceSummary = 1874424,
  Events = 1874425,
  EventsTable = 1874426,
  GlobalConsumption = 1874427
}


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  sectorList: LabelValue<number>[] = [];
  sector: LabelValue<number> = null;
  localityList: LabelValue<number>[] = [];
  locality: LabelValue<number> = null;
  _sectorsFullList: ApolusTypes.Sector[] = [];
  rateList: LabelValue<number>[] = [];
  rate: LabelValue<number> = null;

  dateFrom: CoreTypes.DateTimeDT;
  dateTo: CoreTypes.DateTimeDT;
  status: number = 0;
  loading: boolean = true;
  dashboardData: ApolusTypes.Dashboard = null;
 /*  dashboardData: ApolusTypes.Dashboard = {
    DeviceSummary: { 
      TotalDevices: 13,
      OnlineDevices: 10,
      WithAlarmDevices: 2
    },
    ConnectivityHistory: {
      LeftAxis: {
        AxisTitle: '(m3)',
        MaxValue: 1200,
        MinValue: 0
      },
      RightAxis: null,
      Series: [
        {
          Type: 4, 
          Values: [1000, 1180, 1040, 1020, 1080, 1100, 1100, 1090, 1030, 900, 910, 1100, 1000, 950, 800, 750, 700, 650, 600, 550, 520, 510, 505, 500, 1200],
          AxisID: 1,
          Color: 1099489,
          DataPointFormat: 1,
          LineWidth: 1,
          OfflinePeriods: [],
          Timestamps: [1752724800, 1752768000, 1752811200, 1752854400, 1752897600, 1752940800, 1752984000, 1753027200, 1753070400, 1753113600, 1753156800, 1753200000, 1753243200, 1753286400, 1753329600, 1753372800, 1753416000, 1753459200, 1753502400, 1753545600, 1753588800, 1753632000, 1753675200, 1753718400, 1753761600],
          Title: 'Consumo'
        }
      ],
      Ranges: [],
      TimeAxisMax: {
        Date: {
          Day: 30,
          Month: 7,
          Year: 2025
        },
        Time: {
          Hour: 15,
          Millisecond: 501,
          Minute: 14,
          Second: 2
        }
      },
      TimeAxisMin: {
        Date: {
          Day: 17,
          Month: 7,
          Year: 2025
        },
        Time: {
          Hour: 0,
          Millisecond: 0,
          Minute: 0,
          Second: 0
        }
      },
      TimeAxisFormat: 'dd/MM/yyyy HH:mm',
    },
    ConnectivityTable: [
      {
        Date: { Day: 1, Month: 1, Year: 2025 },
        Percentage: 100,
        Quantity: 30000
      },
      {
        Date: { Day: 2, Month: 1, Year: 2025 },
        Percentage: 100,
        Quantity: 35000
      },
      {
        Date: { Day: 3, Month: 1, Year: 2025 },
        Percentage: 100,
        Quantity: 39000
      },
      {
        Date: { Day: 3, Month: 1, Year: 2025 },
        Percentage: 100,
        Quantity: 38000
      },
      {
        Date: { Day: 3, Month: 1, Year: 2025 },
        Percentage: 100,
        Quantity: 40000
      }
    ],
    GlobalConsumption: {
      "LeftAxis": {
        "AxisTitle": "",
        "MaxValue": 25,
        "MinValue": 0
      },
      "Ranges": [],
      "RightAxis": null,
      "Series": [
        {
          "AxisID": 1,
          "Color": 3368652,
          "DataPointFormat": 2,
          "LineWidth": 1,
          "OfflinePeriods": [],
          "Timestamps": [
            1760400000,
            1760486400,
            1760572800,
            1760659200,
            1760745600,
          ],
          "Title": "Promedio",
          "Type": 1,
          "Values": [ 9, 13, 15, 17, 24]
        }
      ],
      "TimeAxisFormat": "MM/dd",
      "TimeAxisMax": {
        "Date": {
          "Day": 22,
          "Month": 10,
          "Year": 2025
        },
        "Time": {
          "Hour": 20,
          "Millisecond": 858,
          "Minute": 30,
          "Second": 33
        }
      },
      "TimeAxisMin": {
        "Date": {
          "Day": 8,
          "Month": 10,
          "Year": 2025
        },
        "Time": {
          "Hour": 0,
          "Millisecond": 0,
          "Minute": 0,
          "Second": 0
        }
      }
    },
    EventsTable: [
      {
        AlarmDescription: 'Fuga',
        Percentage: 100,
        Quantity: 100
      },
      {
        AlarmDescription: 'Alto consumo',
        Percentage: 100,
        Quantity: 100
      },
      {
        AlarmDescription: 'Tubo vacío',
        Percentage: 100,
        Quantity: 100
      },
      {
        AlarmDescription: 'Flujo reverso',
        Percentage: 100,
        Quantity: 100
      },
      {
        AlarmDescription: 'Fuera de rango',
        Percentage: 100,
        Quantity: 100
      },
      {
        AlarmDescription: 'Temperatura',
        Percentage: 100,
        Quantity: 100
      },
      {
        AlarmDescription: 'Batería baja',
        Percentage: 100,
        Quantity: 100
      },
    ],
    Events: [
      {
        DisplayValue: 'Sin eventos',
        Value: 75,
      },
      {
        DisplayValue: 'Alto Consumo',
        Value: 12.5,
      },
      {
        DisplayValue: 'Batería',
        Value: 5, 
      },
      {
        DisplayValue: 'Medidor caído',
        Value: 5,
      },
      {
        DisplayValue: 'Fuga',
        Value: 2.5,
      },
    ],
   
  }; */

  eventsWidget: any = {
    WidgetID: 3,
    PieChart: {
      ShowLegend: true,
      DisclaimerMessage: ''
    },
    NoDataText: ''
  };

  subscriptions: Subscription[] = [];
  
  constructor(
    private apolusProxyService: ApolusProxyService,
    public apolusService: ApolusService,
    public appService: AppService,
    private cdr: ChangeDetectorRef,
    public gearAppService: GearAppService
  ) {}

  ngOnInit(): void {
    this.initializeData();
    this.initializeDateRanges();

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  initializeDateRanges(): void {
    const today = new Date();
    const dateFrom = new Date(today);
    dateFrom.setDate(today.getDate() - 14);
    dateFrom.setHours(0, 0, 0, 0);
    
    this.dateFrom = {
      Date: {
        Day: dateFrom.getDate(),
        Month: dateFrom.getMonth() + 1,
        Year: dateFrom.getFullYear()
      },
      Time: {
        Hour: 0,
        Minute: 0,
        Second: 0,
        Millisecond: 0
      }
    };
    
    const dateTo = new Date(today);
    dateTo.setHours(23, 59, 59, 999);
    
    this.dateTo = {
      Date: {
        Day: dateTo.getDate(),
        Month: dateTo.getMonth() + 1,
        Year: dateTo.getFullYear()
      },
      Time: {
        Hour: 23,
        Minute: 59,
        Second: 59,
        Millisecond: 999
      }
    }
    this.cdr.detectChanges();
  }

  initializeData() {
    forkJoin([
      this.getSectorsList(),
      this.getRatesList(),
      this.getAddressesList()
    ])
    .subscribe({
      complete: async () => {
        this.cdr.detectChanges();
        this.getDashboardData()
      }
    });
  }

  getDashboardData() {
    this.status = 0;
    this.loading = true;
    this.apolusProxyService.ApolusService.GetDashboard(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      this.locality?.value,
      this.sector?.value,
      this.rate?.value,
      this.dateFrom,
      this.dateTo,
      (data: ApolusTypes.Dashboard) => {
        this.dashboardData = data;
        this.status = 1;
        this.loading = false;
      },
      (err) => {
        this.appService.showException(err);
        this.status = 2;
        this.loading = false;
      }
    );
  }

  getSectorsList(): Observable<any> {
    return new Observable(observer => {
      this.apolusProxyService.ApolusService.EnumSectors(
        this.appService.getAccessToken(),
        (data: ApolusTypes.Sector[]) => {
          this._sectorsFullList = data;
          let items: LabelValue<number>[] = [];
          data.forEach((x, i) => {
            let item = {
              label: x.Description,
              value: x.SectorID
            };
            items.push(item);
          });
          this.sectorList = items;
          this.sector = this.sectorList[0];
          observer.next(true);
          observer.complete();
        },
        (err) => {
          this.appService.showException(err);
          observer.error(err);
        }
      );
    });
  }

  getAddressesList(): Observable<any> {
    return new Observable(observer => {
      this.apolusProxyService.ApolusService.EnumGeocodingAddresses(
        this.appService.getAccessToken(),
        (data: ApolusTypes.GeocodingAddress[]) => {
          let items: LabelValue<number>[] = [];
          data.forEach((x, i) => {
            let item = {
              label: x.StreetName + ' ' + x.StreetNumber,
              value: x.AdminArea2ID
            };
            items.push(item);
          });
          this.localityList = items;
          this.locality = this.localityList[0];
          observer.complete();
        },
        (err) => {
          this.appService.showException(err);
          observer.error(err);
        }
      );
    });
  }

  getRatesList(): Observable<any> {
    return new Observable(observer => {
      this.apolusProxyService.ApolusService.EnumRates(
        this.appService.getAccessToken(),
        (data: ApolusTypes.Rate[]) => {
          let items: LabelValue<number>[] = [];
          data.forEach((x, i) => {
            let item = {
              label: x.Description,
              value: x.RateID
            };
            items.push(item);
          });
          this.rateList = items;
          this.rate = this.rateList[0];
          observer.next(true);
          observer.complete();
        },
        (err) => {
          this.appService.showException(err);
          observer.error(err);
        }
      );
    });
  }

  applyFilters() {
    this.getDashboardData();
  }
}